import { BookOpen, ExternalLink } from "lucide-react";

// Outbound citations to reputable medical bodies — builds E-E-A-T & trust for SEO.
export const MedicalSources = ({ sources = [] }) => {
  if (!sources.length) return null;
  return (
    <div data-testid="medical-sources" className="mt-12 rounded-2xl border border-brand-line bg-brand-soft p-6 md:p-7">
      <div className="flex items-center gap-2 text-brand-dark">
        <BookOpen className="h-5 w-5 text-brand-blue" />
        <h3 className="font-display text-lg font-medium">Medically reviewed sources</h3>
      </div>
      <p className="mt-2 text-sm text-brand-muted">
        Information on this page is aligned with guidance from trusted medical and dental
        organisations:
      </p>
      <ul className="mt-4 flex flex-col gap-2">
        {sources.map((s) => (
          <li key={s.url}>
            <a
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="medical-source-link"
              className="group inline-flex items-center gap-1.5 text-sm font-medium text-brand-blue hover:underline"
            >
              {s.label}
              <ExternalLink className="h-3.5 w-3.5 opacity-70 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
